import { Injectable, Type } from '@angular/core';

import { BettingInsightsMarketOptions } from '@cds/betting-offer/betting-insights';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { ISixPackOptionRow } from '../option-group/six-pack-option-group.component';
import { BettingInsightsModule } from './betting-insights.module';

export interface BettingInsightsBindingModel {
    bettingInsightsMarketOptions: BettingInsightsMarketOptions[];
    optionRows: ISixPackOptionRow[];
    sportId: number;
}

@Injectable({ providedIn: 'root' })
export class BettingInsightsComponentLoaderService extends ComponentLoaderService<BettingInsightsModule> {
    moduleName = 'BettingInsightsModule';

    constructor(moduleLoader: ModuleLoaderService, loggerFactory: LoggerFactory) {
        super(moduleLoader, loggerFactory);
    }

    getModule(): Promise<Type<BettingInsightsModule>> {
        return import('./betting-insights.module').then((m) => m.BettingInsightsModule);
    }

    getBettingInsightsComponent(): ComponentProxy<BettingInsightsBindingModel> {
        return this.getComponentProxy((module) => module.bettingInsightsComponent);
    }
}
